import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Icon } from '@src/elements/icon/icon'
import { Subtitle2 } from '@src/elements/typography/typography'

@Component
export class MuscleMan extends Vue {

  @Prop({ required: true })
  facing: string

  @Prop({ required: false })
  primaryMuscles: string[]

  @Prop({ required: false })
  secondaryMuscles: string[]

  getMusclesHighlight () {
    let style = ''
    this.primaryMuscles.forEach(muscle => {
      style += `.${muscle}{fill: #244DAA} `
    })
    this.secondaryMuscles.forEach(muscle => {
      style += `.${muscle}{fill: #1993ff} `
    })

    return style
  }

  render (h: CreateElement) {
    return <div class={`muscle-${this.facing}`}>
      <Icon name={`muscle/muscle_man_${this.facing}`} />
      <style scoped> {this.getMusclesHighlight()} </style>
      <span><Subtitle2>{this.$t(`PAGE.CONTENT.WORKOUT.EXERCISE_INFO.${this.facing.toUpperCase()}`)}</Subtitle2></span>
    </div>
  }
}
